import type { TweetResponseAuthorBasicInfo } from './tweetResponseAuthorBasicInfo';
import type { TweetResponseAuthorSocial } from './tweetResponseAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TweetResponseAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TweetResponseAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TweetResponseAuthorSocial;
};
